<template>
  <tr class="w-table-row" :class="object.listClasses">
    <td v-if="showCheckbox" class="text-center">
      <input
        v-if="!footRow"
        v-model="object.checked"
        aria-label="Zaznacz wiersz"
        class="mt-2"
        type="checkbox"
        @change="check"
      />

      <b v-else-if="object.checkboxValue">{{ object.checkboxValue }}</b>
    </td>

    <td
      v-for="(column, index) in columns"
      :key="column.name + index"
      :ref="'column_cell_' + index"
      class="column-action middle"
      :class="column.cssClass"
      :style="columnStyle(column, $refs['column_cell_' + index])"
      :colspan="column.colspan"
      @click="$emit(column.action || defaultColumnAction, object)"
      v-html="getValue(object, column)"
    />

    <actions
      :actions="actions"
      :entity-type="entityType"
      :object="object"
      :id-key="idKey"
      :force-not-exact="forceNotExact"
      v-on="$listeners"
    />
  </tr>
</template>

<script>
import generateGuid from '@witkac/jschema/lib/methods/generateGuid';

import { VIEW_ACTION } from '@/utils/constants';
import { getColumnOffset } from '@/utils/getColumnOffset';
import { getColumnValue } from '@/utils/getColumnValue';

import Actions from './Actions';

// @vuese
// Rzędy w tabeli
// @group Table
export default {
  name: 'TRow',
  components: { Actions },
  props: {
    // Kolumny do wyświetlenia
    columns: { type: Array, required: true },
    // Obiekt zawierający dane
    object: { type: Object, required: true },
    // Index obiektu
    objectIndex: { type: Number, required: true },
    // Możliwe do wykonania akcje
    actions: { type: Array, required: false, default: () => [] },
    // Typ encji wyświetlanej w tabeli
    entityType: { type: String, required: false },
    // Klucz identyfikatora
    idKey: { type: String, required: false, default: 'id' },
    // Edytowanie wielu
    showCheckbox: { type: Boolean, required: true },
    // Czy wiersz jest stopką tabeli
    footRow: { type: Boolean, required: false, default: false },
    // Domyślna akcja po kliknięciu w kolumnę
    defaultColumnAction: { type: String, required: false, default: VIEW_ACTION.event },
    // Czy wymuszać sprawdzanie uprawnień do akcji "po staremu" - bez dokładnej encji
    forceNotExact: { type: Boolean, default: false }
  },
  data() {
    return { mounted: false };
  },
  mounted() {
    this.$nextTick().then(() => (this.mounted = !this.mounted));
  },
  methods: {
    // @vuese
    // Pobiera wartość wybranego pola
    getValue(object, column) {
      if (this.footRow && !column.isSumRow) {
        return '';
      }
      if (!this.footRow) {
        object.index = this.objectIndex + 1;
      }

      const value = getColumnValue(
        object,
        column,
        this.footRow && column.preventSumRowTransform ? { fieldWithTransformer: generateGuid() } : undefined
      );

      if (typeof value === 'string') {
        return value.replace(/\n/g, '<br>');
      }

      return value;
    },
    // @vuese
    // Zwraca odległość od lewej strony tabeli
    getOffset(element) {
      this.mounted;
      if (element?.[0]?.classList.contains('sticky-left')) {
        return getColumnOffset(element[0]) + 'px';
      }
    },

    // @vuese
    // Zwraca style kolumny
    columnStyle(column, element) {
      return {
        'max-width': column.maxWidth,
        'min-width': column.width,
        width: column.width,
        left: this.getOffset(element)
      };
    },

    // @vuese
    // Zaznacza wiersz
    check(value) {
      this.$emit('checked', this.object);
    }
  }
};
</script>

<style>
.column-action:hover,
.w-table-row:hover td {
  cursor: pointer;
  background-color: #f0f0f0;
}
.middle {
  vertical-align: middle !important;
}
.dataTable td p {
  margin-bottom: 0;
}
</style>
